module.exports = __webpack_public_path__ + "static/media/cross.02a733ff.svg";